import * as types from '../constants';

export function setUserAction(user) {
  return {
    type: types.SET_USER,
    user: user
  }
}
